import { Tooltip, theme } from '@/components';
import { WarningTwoTone } from '@ant-design/icons';
import type { FC } from 'react';

type Props = {
  hint?: string;
};

export const WarningIcon: FC<Props> = ({ hint }) => {
  const { token } = theme.useToken();
  if (!hint) {
    return <WarningTwoTone twoToneColor={token.colorError} />;
  }
  return (
    <Tooltip title={hint}>
      <WarningTwoTone twoToneColor={token.colorError} />
    </Tooltip>
  );
};
